import { Avatar, Button, Col, Row } from 'antd';
import initials from 'initials';
import { observer } from 'mobx-react';
import { useRootStore } from 'models/rootModel';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const NameContainer = styled.div`
  font-weight: bold;
  padding-top: 8px;
  text-align: center;
`;

const HeaderContainer = styled.div`
  padding-bottom: 8px;
`;

const StyledButton = styled(Button)`
  padding-top: 7px;
  padding-left: 0;
`;

const regex = new RegExp(/[&/\\#[\]|,+()$~%.'":*?<>{}!¤=]/g);

export const EditUserHeader = observer(({ logoutApi, visibleFnc }) => {
  const { t } = useTranslation('geosecma-sidebar');
  const rootStore = useRootStore();
  const { user } = rootStore;

  const onLogout = () => {
    window.location = logoutApi;
  };

  return (
    <HeaderContainer>
      <Row gutter={16}>
        <Col span={4}>
          <Avatar size="large" style={{ backgroundColor: '#0277bd', verticalAlign: 'middle' }}>
            {initials(user.name.replace(regex, ''))}
          </Avatar>
        </Col>
        <Col span={13}>
          <NameContainer data-testid="header-username">{user.name}</NameContainer>
        </Col>
        <Col span={7}>
          <StyledButton
            tabIndex="0"
            data-testid="logoutBtn"
            type="link"
            onClick={onLogout}
            onKeyDown={e => e.key === 'Escape' && visibleFnc(false)}
          >
            {t('general:logout')}
          </StyledButton>
        </Col>
      </Row>
    </HeaderContainer>
  );
});
